import { render } from "./SiteMenu.vue?vue&type=template&id=4978e756&scoped=true"
import script from "./SiteMenu.vue?vue&type=script&lang=js"
export * from "./SiteMenu.vue?vue&type=script&lang=js"

import "./SiteMenu.vue?vue&type=style&index=0&id=4978e756&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4978e756"]])

export default __exports__